import { render, staticRenderFns } from "./App.vue?vue&type=template&id=21e745b4&"
import script from "./App.vue?vue&type=script&async=true&lang=js&"
export * from "./App.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports